var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 22C7.17701 22 2.70001 17.523 2.70001 12C2.70001 6.477 7.17701 2 12.7 2C18.223 2 22.7 6.477 22.7 12C22.7 17.523 18.223 22 12.7 22ZM12.7 20C14.8217 20 16.8566 19.1571 18.3569 17.6569C19.8572 16.1566 20.7 14.1217 20.7 12C20.7 9.87827 19.8572 7.84344 18.3569 6.34315C16.8566 4.84285 14.8217 4 12.7 4C10.5783 4 8.54345 4.84285 7.04316 6.34315C5.54287 7.84344 4.70001 9.87827 4.70001 12C4.70001 14.1217 5.54287 16.1566 7.04316 17.6569C8.54345 19.1571 10.5783 20 12.7 20ZM11.703 16L7.46001 11.757L8.87401 10.343L11.703 13.172L17.359 7.515L18.774 8.929L11.703 16Z",
    fill: "#3C7D4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.84fbf7f49ee031269d8685b47aa95e12.svg";
export { ForwardRef as ReactComponent };